import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource";
import {
  getVehicleMovements,
  getVehicleMovement,
  editVehicleMovement,
  createVehicleMovement,
  deleteVehicleMovement,
  getAllVehicleMovements,
  getTrashedVehicleMovements,
  restoreVehicleMovement,
} from "api/vehicleMovementsApi";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const VEHICLE_MOVEMENT_QUERY_KEY = "vehicle-movements"
export const VEHICLE_MOVEMENT_GROUP_QUERY_KEY = "vehicle-movements-group"

// -------------------- FETCH PAGINATED --------------------
export const useVehicleMovements = (params = {}, enabled = true) => {
  return usePaginatedResource(
    VEHICLE_MOVEMENT_QUERY_KEY,
    getVehicleMovements,
    params,
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useVehicleMovement = (id, enabled = true) => {
  return useResourceItem(VEHICLE_MOVEMENT_QUERY_KEY, getVehicleMovement, id)
}

// -------------------- CREATE --------------------
export const useCreateVehicleMovement = () => {
  return useCreateResource(createVehicleMovement, VEHICLE_MOVEMENT_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditVehicleMovement = () => {
  return useEditResource(editVehicleMovement, VEHICLE_MOVEMENT_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteVehicleMovement = () => {
  return useDeleteResource(deleteVehicleMovement, VEHICLE_MOVEMENT_QUERY_KEY)
}

// -------------------- ADDITIONAL --------------------

// Get all vehicle movements without pagination
export const useAllVehicleMovements = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_MOVEMENT_QUERY_KEY,
    getAllVehicleMovements,
    { ...params, all: true },
    true
  )
}

// Get trashed vehicle movements
export const useTrashedVehicleMovements = (params = {}) => {
  return usePaginatedResource(
    VEHICLE_MOVEMENT_QUERY_KEY,
    getTrashedVehicleMovements,
    params,
    true
  )
}

// Restore a trashed vehicle movement
export const useRestoreVehicleMovement = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: restoreVehicleMovement,
    onSuccess: (res, { id }) => {
      const restoredItem = res?.data
      if (!restoredItem) return

      // Update paginated cache
      queryClient.setQueriesData([VEHICLE_MOVEMENT_QUERY_KEY, "all"], old => {
        if (!old || !old.data || !Array.isArray(old.data.data)) return old
        const updated = structuredClone(old)
        updated.data.data = [restoredItem, ...updated.data.data]
        updated.data.total = (updated.data.total || 0) + 1
        return updated
      })

      // Update individual item cache
      queryClient.setQueryData([VEHICLE_MOVEMENT_QUERY_KEY, id], restoredItem)
    },
  })
}
